import { Link } from "react-router-dom";

interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionTitle({
  eyebrow,
  title,
  description,
  actionLabel,
  actionTo,
}: SectionTitleProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
      <div>
        {eyebrow && (
          <p className="text-xs tracking-[0.2em] text-accent-600 font-label uppercase mb-1">{eyebrow}</p>
        )}
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">{title}</h2>
        {description && (
          <p className="text-sm text-foreground-600 mt-1.5 max-w-2xl">{description}</p>
        )}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-accent-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-base w-5 h-5 flex items-center justify-center" />
        </Link>
      )}
    </div>
  );
}